import angular from 'angular';

export class CustomerService {
  static $inject = [];

  model = {
    customerSource: '',
    customerId: '',
    externalCustomerImportId: '',
    externalCustomerId: '',
    email: '',
    prefix: '',
    suffix: '',
    firstName: '',
    lastName: '',
    middleName: '',
    phoneNumber: '',
    phoneNotes: '',
    orgName: '',
    deceased: '',
  };

  titles = [
    {
      title: 'Ms',
      name: 'Ms',
    },
    {
      title: 'Miss',
      name: 'Miss',
    },
    {
      title: 'Mrs',
      name: 'Mrs',
    },
    {
      title: 'Mr',
      name: 'Mr',
    },
    {
      title: 'Rev',
      name: 'Rev',
    },
    {
      title: 'Dr',
      name: 'Dr',
    },
    {
      title: 'Prof',
      name: 'Prof',
    },
  ];

  getTitles() {
    return this.titles;
  }

  findSalutation(prefix: string) {
    return this.titles.find((option) => option.title.toLowerCase() === prefix.toLowerCase());
  }

  getSalutationName(prefix: string) {
    const found = this.findSalutation(prefix);

    return found ? found.name : '';
  }
}

export const CustomerServiceModule = angular
  .module('acme.common.service.customer', [])
  .service('CustomerService', CustomerService).name;
